/* 欠款管理 wuxuan */
<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <div class="date-picker-v2">
          <el-date-picker
            class="query-date-picker"
            v-model="queryYear"
            type="monthrange"
            format="yyyy-MM"
            value-format="yyyy-MM"
            :range-separator="$t('rangeSeparator')"
            start-placeholder="开始年份"
            end-placeholder="结束年份"
            @change="search"
          />
        </div>
        <div class="input-v2">
          <el-input v-model="formInline.name" placeholder="导入人" suffix-icon="el-icon-search" clearable @keyup.native.enter="search"></el-input>
        </div>
        <div class="input-v2 ml16">
          <el-input v-model="formInline.batchId" placeholder="导入批次编码" suffix-icon="el-icon-search" clearable @keyup.native.enter="search"></el-input>
        </div>
      </div>
      <div class="title-right">
        <el-button class="button-v2" type="primary" @click="add">创建批次</el-button>
      </div>
    </div>
    <div class="table-body flex vertical" v-loading="loading">
      <air-table
        ref="airTable"
        class="table-v2"
        :show-checkbox="false"
        align="center"
        :columns="customList"
        :data="tableData"
      >
        <template #operation="{ row }">
          <div class="flex center">
            <span class="text-button" @click="handleClick(row)">详情</span>
          </div>
        </template>
      </air-table>
      <bsp-pagination
        :pager-config.sync="msgPage"
        @page-change="handleCurrentChange"
        @page-size-change="handleSizeChange"
        show-page-size
      />
    </div>
    <!-- 创建批次弹框 -->
    <el-dialog
      class="modal-v2 has-padding"
      ref="cusPaysetDialog"
      v-dialogDrag title="创建批次"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="addUpload"
      append-to-body
      width="600px"
    >
      <el-form class="form-v2 upload-modal" ref="form" :model="form" label-width="80px">
        <el-form-item label="年度">
          <el-date-picker
            class="date-picker-v2 has-icon w100"
            v-model="form.year"
            type="year"
            format="yyyy"
            value-format="yyyy">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="月份">
          <el-select placeholder="月份" v-model="form.month" class="select-v2">
            <el-option
              v-for="item in mouth"
              :key="item"
              :label="item+'月'"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件上传">
          <el-upload
            v-loading="loading"
            class="text-left"
            name="file"
            ref="upload"
            action="#"
            :before-upload="beforeFileUpload"
            :show-file-list="true"
            :http-request="fileUploadSuccess"
            :on-remove="handleRemove"
            limit=1
            drag
          >
            <div v-if="!uploadFlag">
              <i class="el-icon-upload"/>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </div>
            <el-button class="uploadFlag" type="success" icon="el-icon-check" circle v-else></el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button class="button-v2" plain @click="close()">取消</el-button>
        <el-button type="primary" class="button-v2" @click="_importExcel()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
    importExcel,
    getloadTaxData
} from "@/api/tesla/debtManagement.js";
export default {
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  created(){
    this.form.cusId = this.userInfo.cusId
    this.form.cusName = this.userInfo.cusName
    this.form.branchId = this.userInfo.branchId
    this.form.userId = this.userInfo.userId
    this.form.userName = this.userInfo.loginName
    this._getloadTaxData()
  },
  data() {
    return {
        msgPage: {
          limit: 10,
          page: 1,
          total: 0,
        },
        formInline:{
          queryYear:[],
          name:'',
          batchId:''
        },
        form:{
         cusId:'',
         branchId:'',
         year:this.$day().format('YYYY'),
         month:this.$day().format('MM'),
         userId:'',
         userName:''
        },
        mouth:[...'123456789','10','11','12'],
        loading: false,
        importUrl: '/api/sys/taxManage/importExcel',
        addUpload:false,
        tableData: [],
        file: null,
        uploadFlag:false,
        customList: [
        {
          title: "年度",
          field: "taxYear",
        },
        {
          title: "月份",
          field: "taxMonth",
        },
        {
          title: "欠款总金额",
          field: "owedAmount",
          formatFunction(row) {
            return row.owedAmount + '万元'
          }
        },
        {
          title: "已确认金额",
          field: "confirmedAmount",
          formatFunction(row) {
            return row.confirmedAmount + '万元'
          }
        },
        {
          title: "发送人数",
          field: "sentNum",
        },
        {
          title: "已确认人数",
          field: "confirmedNum",
        },
        {
          title: "导入时间",
          field: "importDate",
        },
        {
          title: "导入人",
          field: "importEmpName",
        },
        {
          title: "导入批次编码",
          field: "importBatchNo",
        }
      ]
    };
  },
  methods: {
    add() {
        this.addUpload = true;
    },
    close(){
      this.addUpload = false;
      this.file=null;
      this.uploadFlag=false;
      this.form.month = this.$day().format('MM');
      this.form.year =this.$day().format('YYYY');
      this.$refs['upload'].clearFiles();
      
    },
    handleClick(row) {
      this.$router.push('/wage/debtDetails?batchId='+row.id+'&importDate='+row.importDate);
    },
    handleSizeChange(val) {
        this.msgPage.limit = val;
        this._getloadTaxData(this.formInline)
    },
    handleCurrentChange(val) {
        this.msgPage.page = val;
        this._getloadTaxData(this.formInline)
        console.log(`当前页: ${val}`);
    },
    // 删除
    deleteRow(index, rows) {
        rows.splice(index, 1);
        // addCenter(this.form).then(res=>{
        //   console.log('删除')
        // })
    },
    fileUploadSuccess(response, file, fileList) {
        this.file = response.file;
        this.$set(this, "loading", false);
        this.uploadFlag = true
        
    },
    handleRemove(file, fileList) {
        this.uploadFlag=false
    },
    fileUploadError(err, file, fileList) {
        this.$set(this, "loading", false);
        this.$message.error( "导入失败!" );
    },
    beforeFileUpload(file) {
        this.$set(this, "loading", true);
        let isExcel = true;
        const isxls = file.type === "application/vnd.ms-excel";
        const isxlsx = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const isLtM = file.size / 1024 / 1024 < 10;

        if (!isxls && !isxlsx) {
          isExcel = false;
          this.$message.error("导入文件只能是 xls,xlsx 格式!");
          this.$set(this, "loading", false);
        }
        if (!isLtM) {
          this.$message.error("导入文件大小不能超过 10MB!");
          this.$set(this, "loading", false);
        }
        return isExcel && isLtM;
    },
    // 查询
    search(){
      // this._getCostCenterComparisonColumns(this.formInline)
    },
    // 初始化数据
    _getloadTaxData() {
      let params = {
        pageNum:'1',
        page: this.msgPage.page,
        limit: this.msgPage.limit,
        batchId:this.formInline.batchId//批次id
      }
      getloadTaxData({
        param: JSON.stringify(params)
      }).then(res=>{
        if(res.data.code==0) {
          this.tableData = res.data.data.dataList
          this.msgPage.total = parseInt(res.data.data.total)
        }
      })
    },
    // 创建批次
    _importExcel() {
        const form = new FormData();
        form.append("file", this.file);
        console.log(this.form)
        const params = {
          param: JSON.stringify(this.form)
        }
        importExcel(form, params).then(res=>{
          if(res.data.code == 0) {
            this.addUpload = false;
            this._getloadTaxData()
          }
        })
    }
  }
};
</script>
<style lang="scss" scoped>
  .uploadFlag{
    font-size: 57px !important;
    background: #67C23A !important;
    margin: 52px 0 16px !important;
    line-height: 50px !important;
  }
</style>
